import { Component, OnInit, Input, Output, EventEmitter, AfterViewInit, ChangeDetectorRef } from '@angular/core';
import { Injectable } from "@angular/core";
// import { Config } from "./config";

import { Http, Response } from "@angular/http";
import 'rxjs/add/operator/map';
@Injectable()

@Component({
  selector: 'app-youtube-search-enrichments',
  templateUrl: './youtube-search-enrichments.component.html',
  styleUrls: ['./youtube-search-enrichments.component.css']
})
export class YoutubeSearchEnrichmentsComponent implements OnInit {

  @Input() youtubeSearch: any;
  @Output() globalServicesCallBack: EventEmitter<any> = new EventEmitter<any>();
  public results = [];
  public inputLink = "";
  public pageToken = "";
  public selectedVideoIndex: number;
  public currentVideoId;

  constructor(private http: Http, private cdr: ChangeDetectorRef) { }

  ngOnInit() {
  }

  close() {
    this.hideYoutubeSearchDialog(undefined);
  }

  clearInput() {
    this.inputLink = "";
    this.results = [];
    this.pageToken = "";
    this.selectedVideoIndex = undefined;
  }

  hideYoutubeSearchDialog(evt) {
    if (evt) {
      evt.stopPropagation();
    }
    else {
      this.results = [];
      this.pageToken = "";
      this.selectedVideoIndex = undefined;
      this.youtubeSearch.showPopup = false;
    }
  }

  inputChange() {
    if (this.inputLink.length <= 1) {
      this.results = [];
      this.pageToken = "";
      this.selectedVideoIndex = undefined;
    }
  }

  //On selecting video
  onVideoClick(obj, ind) {
    this.selectedVideoIndex = ind;
    this.currentVideoId = obj.id
  }

  addAsTab() {
    if (this.currentVideoId && this.currentVideoId.length > 0) {
      var obj = {
        "id": 8,
        "icon": "Youtube",
        "text": "Youtube",
        "color": "#d63a3a",
        "type": "youtube",
        "videoId": this.currentVideoId
      }
      this.globalServicesCallBack.emit(obj);
      this.hideYoutubeSearchDialog(undefined);
    }
  }

  ngAfterViewInit() {

  }

  //To search youtube results
  search() {
    if (this.inputLink.length == 0) {
      return;
    }
    this.http
      .get('https://www.googleapis.com/youtube/v3/search?&part=snippet&type=video&maxResults=20&key=AIzaSyCnhGD-oIUb-JJi_X481sat_hRh64MsCg0&pageToken=' + this.pageToken + '&q=' + this.inputLink + '')
      .subscribe(res => {
        var data = JSON.parse(res['_body']);
        this.pageToken = data.nextPageToken;
        this.listResults(data);
      });
  }

  //
  listResults(data) {
    //for (var i = data.items.length - 1; i >= 0; i--) {
    for (var i = 0; i < data.items.length; i++) {
      this.results.push({
        id: data.items[i].id.videoId,
        title: data.items[i].snippet.title,
        description: data.items[i].snippet.description,
        thumbnail: data.items[i].snippet.thumbnails.default.url,
        author: data.items[i].snippet.channelTitle
      });
    }
    this.cdr.detectChanges();
  }

}



// WEBPACK FOOTER //
// ./src/app/bookShared/enrichmentTabs/youtube-search-enrichments/youtube-search-enrichments.component.ts